import styled, { css } from 'styled-components';
import BetbleLogo from 'images/sports/common/betble_logo.png';
import BetbleFullLogo from 'images/sports/common/betble_full_logo.png';
import XBET from 'images/sports/common/logo/1XBET.png';
import TENBET from 'images/sports/common/logo/10BET.png';
import BET365 from 'images/sports/common/logo/BET365.png';
import DAFABET from 'images/sports/common/logo/DAFABET.png';
import SBOBET from 'images/sports/common/logo/SBOBET.png';
import WILLIAM from 'images/sports/common/logo/WILLIAM.png';
import BETMAN from 'images/sports/common/logo/BETMAN.png';

export const SiteLogo = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 60px;
  height: 20px;
  ${(props) =>
    props.siteLogo === 'XBET' &&
    css`
      background: url(${XBET}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'TENBET' &&
    css`
      background: url(${TENBET}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'BET365' &&
    css`
      background: url(${BET365}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'DAFABET' &&
    css`
      background: url(${DAFABET}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'SBOBET' &&
    css`
      background: url(${SBOBET}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'WILLIAM' &&
    css`
      background: url(${WILLIAM}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'BETMAN' &&
    css`
      background: url(${BETMAN}) no-repeat;
      background-size: contain;
    `};
`;

export const BetbleSite = styled.div`
  display: inline-block;
  width: 60px;
  height: 20px;
  vertical-align: middle;
  background: #64666d;
  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: url(${BetbleFullLogo}) no-repeat center center;
    background-size: 60%;
  }
`;

export const BetbleLink = styled.a`
  margin-left: 5px;
  display: inline-block;
  text-align: center;
  line-height: 18px;
  background: #fff;
  border: 1px solid #d0cfd3;
  height: 18px;
  width: 45px;
  font-size: 11px;
  cursor: pointer;
  border-radius: 5px;
  padding-top: 1px;
  letter-spacing: -1px;

  vertical-align: middle;
  &:before {
    vertical-align: middle;
    content: '';
    margin-right: 6px;
    display: inline-block;
    width: 8px;
    height: 11px;
    background: url(${BetbleLogo}) no-repeat center center;
    background-size: cover;
  }
`;
